import React from "react";
import MapRcci from "../../components/Map/MapRcci/MapRcci.tsx";

const Rcci = () => {
  return <MapRcci />;
};

export default Rcci;
